module.exports = "https://static.energy5.com/_next/static/images/evBgEffect-f2df181a645f8471df15c72088cb4a71.webp";